import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { loadDealer } from 'modules/dealers/actions';
import { getDealerById } from 'selectors/dealerSelectors';
import { Tooltip } from 'ui/base';

/** @type {React.FC<{ dealerId: string, tooltip: boolean }>} */
const OptionContent = ({ dealerId, tooltip }) => {
  const dispatch = useDispatch();
  const dealer = useSelector(state => getDealerById(state, dealerId));
  const isLoaded = typeof dealer !== 'undefined';

  React.useEffect(() => {
    if (!isLoaded) {
      dispatch(loadDealer(dealerId));
    }
  }, []);

  return (
    <React.Fragment>
      {!isLoaded && <FormattedMessage id="page.stats.loading" defaultMessage="Loading..." />}
      {isLoaded && (
        <Tooltip placement="left" title={tooltip && dealer.name}>
          {dealer.name}
        </Tooltip>
      )}
    </React.Fragment>
  );
};

export default OptionContent;
